import styled from "styled-components";
import { Gray20, WerfenColor, WerfenColorContrast, White } from '../Constants/ColorChart';

export const Wrapper = styled.div`
    min-height: 100vh;
    background: ${ WerfenColor };
    position: relative;
    display: flex;
    align-items: center;
    font-size: 17px;
    
    .Stage {
        width: 100vw
        label {
            color: ${ White };
            font-weight: 400;
        }
    }
         
    input {
        display: block;
        box-sizing: border-box;
        width: 100%;
        border-radius: 0;
        border: 1px solid ${ White };
        padding: 10px 15px;
        margin-bottom: 10px;
    }
    
    label {
        line-height: 2;
        text-align: left;
        color: ${ White };
        font-weight: 400;
    }
    
    button,
    input[type="submit"] {
        text-transform: uppercase;
        border: none;
        border-radius: 0;
        margin-top: 40px;
        font-size: 16px;
    }
    
    button {
        display: block;
        appearance: none;
        width: 100%;
    }
    
    input:disabled {
        opacity: 0.4;
    }
    
    input[type="button"],
    input[type="submit"] {
        -webkit-appearance: none;
    }



    .Logo {
        position: relative;
        max-width: 400px;
        width: 100%;
        display:block; 
        margin: 0 auto;
        box-sizing: content-box;
        padding: 15px 0px 35px 0px;
        @media (max-width: 992px){
            width: 200px;
        }
    }
    .buttonSubmit {
        background: ${ White };
        color: ${ WerfenColor };
        font-size: 15px;
        font-weight: 400;
        padding-top: 10px;
        padding-bottom: 10px;
        text-align: center;
        -webkit-transition: all 300ms;
        transition: all 300ms;
        display: block;
        width: 200px;
        margin: 0 auto;
    }
    .form-select {
      display: block;
      height: 42px;
      line-height: 21px;
      margin-top: -1px;
      border: 0 none transparent;
      width: 100%;
    }
    input[type="checkbox"], 
    input[type="radio"] {
        display: inline;
        width: auto;
        margin-right: 8px;
        }
    .checkBox .control-label {
        margin-top: 8px;
        line-height: 24px;
        display: flex;
        align-items: first baseline;
    }
    .form-group {
        position: relative;
    }
    .help-block {       
        display: inline-block;
        margin-top: 5px;
        margin-bottom: 10px;
        color: ${ White };
        position: absolute;
        top: 0;
        right: -10px;
        padding: 2px 10px;
        border-radius: 10px;
        background-color: ${ WerfenColorContrast };
        /* background-color: ${ White }; */
        text-shadow: 1px 1px 2px ${ Gray20 };
        font-size: 14px;
        &-large {
            top: -10px;
        }
    }
    .form-group.col-xs-4 {
        margin-bottom: 0;
    }

    .businessLinesWrapper {
        position: relative;
        .help-block {
            position: static;
            display: inline-block;
        }
        .control-label {
            display: inline-block;
            margin-right: 8px;
        }
    }
    .confirmation-message,
    .verification-message{
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
   }
   
   p {
        color: ${ White }
    }
`